class BlogSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.form = this.root.querySelector("form");
        this.filterRootDivs = this.form.querySelectorAll(".form-select");
        this.pageInput = this.form.querySelector("[name='page']");
        this.loadMoreButtonWrapper = this.root.querySelector(".blog__button-wrapper");
        this.loadMoreButton = this.loadMoreButtonWrapper.querySelector(".js-load-more-button");
        this.htmlWrapper = this.root.querySelector(".blog__list");
        this.loader = this.root.querySelector(".loader");

        this.filtersShowButton = this.root.querySelector(".blog__filters-button");
        this.closeFiltersButton = this.form.querySelector(".blog__filters-close");
        this.filterButton = this.form.querySelector(".js-filter-button");

        this.currentPage = 1;
        this.maxNumPages = parseInt(this.root.getAttribute("data-max-pages"));

        this.isDesktop = window.innerWidth > 991.98;

        return true;
    }

    init() {
        if (this.filterRootDivs.length > 0) this.handleSelectEvent();
        if (this.loadMoreButton) this.handleLoadMoreEvent();
        if (this.filtersShowButton) this.handleFiltersShowButtonClick();
        if (this.closeFiltersButton) this.handleFiltersCloseButtonClick();
        if (this.filterButton) this.handleFilterButtonClick();

        window.addEventListener("resize", () => {
            this.isDesktop = window.innerWidth > 991.98;
        })
    }

    handleSelectEvent() {
        this.filterRootDivs.forEach(selectDiv => {
            selectDiv.addEventListener("onSelectChange", (e) => {
                if (this.isDesktop) {
                    this.setPage(1);
                    setTimeout(() => {
                        this.fetchData(true);
                    }, 100);
                }
            })
        });
    }

    handleLoadMoreEvent() {
        this.loadMoreButton.addEventListener("click", (e) => {
            this.setPage(this.currentPage + 1);
            this.fetchData();
        })
        this.loadMoreButton.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
                e.preventDefault();
                this.setPage(this.currentPage + 1);
                this.fetchData();
            }
        })
    }

    handleButtonVisibility() {
        if (parseInt(this.maxNumPages) === 1 || parseInt(this.currentPage) === parseInt(this.maxNumPages)) {
            this.loadMoreButtonWrapper.classList.add("d-none");
        } else {
            this.loadMoreButtonWrapper.classList.remove("d-none");
        }
    }

    handleFiltersShowButtonClick() {
        this.filtersShowButton.addEventListener("click", this.showFilters.bind(this));
    }

    handleFiltersCloseButtonClick() {
        this.closeFiltersButton.addEventListener("click", this.hideFilters.bind(this));
    }

    handleFilterButtonClick() {
        this.filterButton.addEventListener("click", () => {
            this.setPage(1);
            setTimeout(() => {
                this.fetchData(true);
                this.hideFilters();
            }, 100);
        })
    }

    showFilters() {
        this.form.classList.add("-active");
    }

    hideFilters() {
        this.form.classList.remove("-active");
    }

    async fetchData(replaceHtml = false) {
        const formData = new FormData(this.form);
        this.loader.classList.add("-active");
        
        try {
            const req = await fetch(ajax.url, {
                method: "POST",
                body: formData,
            });
            
            if (!req) {
                console.log("Error");
                return;
            }

            const {html, max_pages} = await req.json();

            this.maxNumPages = max_pages || 1;

            if (replaceHtml) {
                this.htmlWrapper.innerHTML = html;
            } else {
                this.htmlWrapper.innerHTML = this.htmlWrapper.innerHTML + html;
            }

        } catch (error) {
            console.log(`Error: ${error}`);
        } finally {
            this.handleButtonVisibility();
            this.loader.classList.remove("-active");
        }
    }

    setPage(pageToSet) {
        this.currentPage = pageToSet;
        this.pageInput.value = pageToSet;
    }
}


const blogSections = document.querySelectorAll("section.blog");

if (blogSections.length > 0) {
    blogSections.forEach(section => {
        const blogSectionClass = new BlogSection(section);
    });
}